import React from "react"
import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../state/hooks"
import { setProductPreview } from "../../state/product"

const ImagePreviewer: React.FC = () => {
  const preview = useAppSelector(state => state.product.productPreviewSrc)
  const dispatch = useAppDispatch()
  const closeView = () => dispatch(setProductPreview(""))
  function handleEscapePress(this: Document, event: KeyboardEvent): void {
    if (event.keyCode === 27) {
      closeView()
    }
  }
  useEffect(() => {
    document.addEventListener("keydown", handleEscapePress, false)
    return function cleanup() {
      document.removeEventListener("keydown", handleEscapePress, false)
    }
  })

  if (!preview) return null
  return (
    <div
      className="overscroll-none"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        position: "fixed",
        width: "100%",
        height: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 10000,
      }}
      onMouseDown={closeView}
    >
      <div
        style={{
          position: "relative",
          height: "100%",
          maxWidth: "100%",
          maxHeight: "100%",
          width: "auto",
          zIndex: 10001,
        }}
      >
        <button
          className="absolute top-0 right-0 hidden p-4 text-2xl text-black lg:static"
          aria-label="click to close preview"
          style={{
            zIndex: 10001,
          }}
          onClick={closeView}
        >
          ✕
        </button>
        <button
          className="absolute bottom-0 w-full p-4 text-2xl text-white bg-black lg:hidden"
          aria-label="click to close preview"
          style={{
            zIndex: 10001,
          }}
          onClick={closeView}
        >
          CLOSE PREVIEW
        </button>
        <img
          src={preview}
          style={{
            objectFit: "cover",
            height: "95%",
          }}
          onMouseDown={evt => evt.stopPropagation()}
          alt="blown up product image"
        />
      </div>
    </div>
  )
}

export default ImagePreviewer
